import _ from 'lodash'
import moment, { Moment } from 'moment'
import { habitTypes } from '../components/HabitsPanel'
import { NewHabitType } from '../components/TargetScores'
import { Score } from './dataFormatting'

export const calcStreakForHabitType = ({
  scores,
  habitType,
  day,
}: {
  scores: Score[]
  habitType: NewHabitType
  day?: Moment
}): number => {
  let count = 0
  let currentDay = day ? moment(day) : moment()

  const scoresMatchingType = scores.filter((s) => s.habitType === habitType)

  if (!scoresMatchingType.find((s) => s.day.isSame(currentDay, 'day'))) {
    currentDay = moment(currentDay).subtract(1, 'day')
  }

  while (true) {
    if (currentDay.day() === 0)
      currentDay = moment(currentDay).subtract(1, 'day')

    const score = scoresMatchingType.find((s) =>
      s.day.isSame(currentDay, 'day')
    )
    if (score) {
      count++
      currentDay = moment(currentDay).subtract(1, 'day')
    } else {
      break
    }
  }

  return count
}

export type Streak = { habitType: NewHabitType; length: number }

export const calcStreaks = (scores: Score[]): Streak[] => {
  return habitTypes.map((habitType) => ({
    habitType,
    length: calcStreakForHabitType({ scores, habitType }),
  }))
}
